import { createStore } from "solid-js/store";
import { useApplication } from "@/context/app";
import { get, save } from "../requests/payment";
import { uncleared } from "../requests/appointment";
import { createSignal, onMount } from "solid-js";
import { useNavigate } from "@solidjs/router";
export default function usePaymentForm(props) {

  const navigate = useNavigate();

  const [loading, setLoading] = createSignal(false);
  const [fetching, setFetching] = createSignal(false);
  const [appointments, setAppointments] = createSignal([]);
  const [key, setKey] = createSignal(null);
  const [form, setForm] = createStore({
    date: new Date(),
    appointmentId: null,
    amount: 0,
    discount: 0,
  });

  const clearForm = (appointmentId = null) => {
    setForm('date', new Date());
    setForm('appointmentId', appointmentId);
    setForm('amount', 0);
    setForm('discount', 0);
  }

  const fetchInfo = async (pid) => {
    setFetching(true);
    setKey(pid);
    try {
      console.log(key());
      const response = await get(key());
      const data = response.entity;
      setForm('date', data.date);
      setForm('appointmentId', data.appointmentId);
      setForm('amount', data.amount);
      setForm('discount', data.discount);
    } catch (error) {
      throw error;
    }  finally {
      setFetching(false);
    }
  }

  const { successToast, errorToast } = useApplication();

  const handleInput = (ev) => {
    setForm([ev.currentTarget.name], ev.currentTarget.value);
  };

  const handleChange = (name, value) => {
    setForm([name], value);
  };

  const handleSave = async (ev) => {
    ev?.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData();
      Object.keys(form).forEach(key => {
        if (key === 'date') {
          return;
        }

        if (key === 'appointmentId') {
          return;
        }

        formData.append(key, form[key])
      });
      if (key() !== null) {
        formData.append('id', key());
      }

      formData.append('date', form.date.getTime());
      if (form.appointmentId === null) {
        errorToast('Please select an appointment');
        return;
      } else {
        formData.append('appointmentId', form.appointmentId);
      }

      const data = await save(formData);

      if (data.success) {
        successToast(data.message);
        props?.onClose();
        props?.onRefresh();
        return;
      }

      errorToast(data.message);
    } catch (error) {
      errorToast(error);
    } finally {
      setLoading(false);
    }
  };

  onMount(async () => {
    try {
      const data = await uncleared();
      setAppointments(data.list);
    } catch(error) {
      setAppointments([]);
    }
  })

  return {
    loading,
    clearForm,
    fetching,
    form,
    fetchInfo,
    handleSave,
    handleInput,
    handleChange,
    appointments,
  };
}
